import React, { useEffect } from 'react';
import { LuX } from 'react-icons/lu';

const sizeMap = { sm: 'sm:max-w-md', md: 'sm:max-w-xl', lg: 'sm:max-w-3xl', xl: 'sm:max-w-5xl' };

export default function Modal({ isOpen, onClose, title, children, size = 'md' }) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4 bg-[#0a1916]/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={`bg-white w-full ${sizeMap[size]} flex flex-col overflow-hidden
          rounded-t-2xl sm:rounded-2xl shadow-hajj-lg
          max-h-[92vh] sm:max-h-[90vh]`}
        onClick={e => e.stopPropagation()}
      >
        {/* Drag handle on mobile */}
        <div className="flex justify-center pt-3 pb-1 sm:hidden">
          <div className="w-10 h-1 rounded-full bg-gray-200" />
        </div>

        <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-hajj-light flex-shrink-0">
          <h3 className="text-sm font-bold text-hajj-dark">{title}</h3>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:bg-hajj-cream hover:text-gray-700 transition-all text-lg"
          >
            <LuX />
          </button>
        </div>
        <div className="p-5 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
